import { css, Theme } from "@emotion/react";
import { theme } from "styles/theme";

export const ModalInformationStyle = {
  wrapper: css`
    width: 998px !important;
    .ant-modal {
      &-content {
        padding: unset;
        background: transparent;
      }
      &-title {
        color: white;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        span {
          font-size: 12px;
          margin-left: 5px;
        }
      }
      &-header {
        margin-bottom: 0;
        background: transparent;
      }
      &-footer {
        background: ${theme.colors.orange[200]};
        height: 20px;
        border-radius: 0 0 4px 4px;

        margin-top: unset;
      }
      &-body {
        background-color: white;
      }
      &-close {
        top: 25px;
        color: white !important;

        &:hover {
          color: unset;
          background-color: unset;
          text-decoration: unset;
        }

        .ant-modal-close-x {
          font-size: 13px;
        }
      }
    }
  `,

  mainContent: css`
    background-color: white;
    height: 626px;
  `,

  header: css`
    color: #fff;
    background: ${theme.colors.orange[200]};
    text-align: center;
    padding-bottom: 5px;

    span {
      font-size: 16px;
      font-weight: bold;
    }
  `,

  footer: css``,

  contentWrap: css`
    display: flex;
  `,

  sideBar: css`
    width: 250px;
    height: calc(626px - 30.13px);

    border-right: 1px solid #ccc;
  `,

  sideBarItem: ({ colors }: Theme) => css`
    display: flex;
    align-self: center;
    gap: 6px;
    width: 100%;
    padding: 12px 12px;
    color: #000;
    border-bottom: 1px solid #ccc;
    height: 50px;
    cursor: pointer;
    &:first-of-type {
      border-top: 1px solid #ccc;
    }
    &.active {
      background: ${theme.colors.orange[100]};
      color: ${colors.white};
      svg,
      path {
        fill: ${colors.white};
      }
    }

    span {
      flex: 1;

      display: inline-block;
      vertical-align: top;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    svg {
      &:first-of-type {
        width: 14px;
        fill: red;
      }
      &:last-of-type {
        width: 8.75px;
      }
    }
  `,

  content: css`
    height: calc(626px - 30.13px);
    overflow-y: auto;
  `,
};
